import styles from "../styles.scss";
import { InputFile } from "@/components/input-file";
import { Button, ButtonSize, ButtonVariant } from "@/components";
import { ChangeEvent, FC } from "react";
import { AttachmentField } from "@/pages/requests/components/attachments/types";
import { FileDataProps } from "@/services";
import { ArrowUpLong } from "@/assets/icons";

interface UploadRowProps {
  id: AttachmentField;
  onUploadDocument: (e: ChangeEvent<HTMLInputElement>) => void;
  onDownloadDocument?: (file?: FileDataProps, isTemplate?: boolean) => void;
  templateName?: string | null;
  templateBase64?: string | null;
  templateExtension?: string | null;
}
export const UploadRow: FC<UploadRowProps> = ({
  id,
  onUploadDocument,
  onDownloadDocument,
  templateName,
  templateBase64,
  templateExtension,
}) => {
  return (
    <div className={styles.actionBtnGroup}>
      {templateBase64 && templateExtension && (
        <Button
          variant={ButtonVariant.Transparent}
          size={ButtonSize.Small}
          onClick={() => {
            if (onDownloadDocument) {
              onDownloadDocument(
                {
                  name: templateName || "",
                  base64: templateBase64,
                  FileBase64: templateBase64,
                  type: templateExtension,
                  size: 100,
                },
                true,
              );
            }
          }}
        >
          <ArrowUpLong /> Download Template
        </Button>
      )}
      <InputFile
        id={id}
        requiredOnly={templateExtension ?? null}
        onChange={e => onUploadDocument(e)}
        labelClassName={styles.inputLabel}
        label={
          <Button
            className={styles.inputLabelButton}
            variant={ButtonVariant.Secondary}
            size={ButtonSize.Small}
          >
            <ArrowUpLong /> Upload File
          </Button>
        }
      />
    </div>
  );
};
